import { render, staticRenderFns } from "./DuplicateLogin.vue?vue&type=template&id=f10d64bc&scoped=true"
import script from "./DuplicateLogin.vue?vue&type=script&lang=ts"
export * from "./DuplicateLogin.vue?vue&type=script&lang=ts"
import style0 from "./DuplicateLogin.vue?vue&type=style&index=0&id=f10d64bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d64bc",
  null
  
)

export default component.exports